import styled from "styled-components";

import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { AudioPlayer } from "../../../../Common";
import { useFindContent } from "../../useFindContent";
import PreviewLayout from "../PreviewLayout";
import AudioProps from "./Audio";

const AudioPreview = ({
  id,
  setIsAudioCreated,
  onDeleteAudio,
}: AudioProps.AudioPreviewProps) => {
  const { post_id, content_data } = useFindContent(
    id
  ) as ArticleProps.WithAudioContent;
  const {
    title,
    description,
    id: audioId,
    image_id,
    background_type,
    background_value,
  } = content_data;

  return (
    <PreviewLayout
      onDelete={onDeleteAudio}
      onEdit={() => setIsAudioCreated(false)}
      width="100%"
    >
      <Container>
        <AudioPlayer
          audioBackgroundImage={{
            id: audioId,
            post_id,
            image_id,
            background_type,
            background_value,
          }}
          id={audioId}
          audio_title={title}
          audio_description={description}
          isViewOnly={false}
          selectedCollaborator={[]}
        />
      </Container>
    </PreviewLayout>
  );
};

export default AudioPreview;

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
`;
